import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DrawerContent } from 'components/common/drawer/DrawerContent';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import { addQuoteSetSchema } from '../../validation/form/marketplace';
import { createQuoteSet } from 'store/slices/marketplace';
import { useAutocompleteProperties } from 'hooks/useAutocompleteProperties';
import { useAsyncDispatch } from 'hooks/useAsyncDispatch';
import { listAllAutocompleteProperties, listAllAutocompletePropertiesNext } from 'store/slices/properties';
import { FormAutocompleteField } from 'components/common/form/Form';

export const NewQuoteSet = (props) => {
  const { close } = props;
  const dispatch = useDispatch();
  const dispatchAction = useAsyncDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const formLoading = useSelector((state) => state.marketplace.newQuoteSetForm.loading);
  const { loading, allProperties, offset, hasMore } = useAutocompleteProperties();

  const methods = useForm({
    resolver: yupResolver(addQuoteSetSchema),
    defaultValues: {
      property: {},
    },
  });

  const handleSave = methods.handleSubmit((data) => {
    dispatchAction(createQuoteSet(data), {
      onSuccess: (data) => {
        navigate(`properties/${data?.property_id}/marketplace/${data?.id}`);
        enqueueSnackbar('Quote has been added');
        close();
      },
    });
  });

  return (
    <DrawerContent>
      <DrawerContent.Header title="New Quote" />
      <DrawerContent.Wrapper>
        <DrawerContent.Content>
          <FormProvider {...methods}>
            <FormAutocompleteField
              name="property"
              label="Select Property"
              control={methods.control}
              optionsData={allProperties}
              optionName="name"
              loading={loading}
              hasMore={hasMore}
              backendSearch={(query) => dispatch(listAllAutocompleteProperties({ query }))}
              fetchData={(query) => dispatch(listAllAutocompletePropertiesNext({ offset, query }))}
            />
          </FormProvider>
        </DrawerContent.Content>
        <DrawerContent.ActionButtons
          submitButtonText="Create"
          submitButtonLoading={formLoading}
          submit={handleSave}
          close={close}
        />
      </DrawerContent.Wrapper>
    </DrawerContent>
  );
};
